import { C, FONTS } from '../../tokens/design';

export default function ColorPicker({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label style={{ fontSize: 11, color: C.t2, fontFamily: FONTS.mono, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {label}
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <input
          type="color"
          value={value || '#000000'}
          onChange={e => onChange(e.target.value)}
          style={{ width: 40, height: 40, border: 'none', borderRadius: 6, cursor: 'pointer', background: 'none', padding: 2 }}
        />
        <input
          type="text"
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder="#000000"
          maxLength={7}
          style={{
            background: C.s2, border: `1px solid ${C.b1}`, borderRadius: 6,
            padding: '8px 12px', color: C.t1, fontSize: 13, fontFamily: FONTS.mono,
            width: 100, outline: 'none',
          }}
        />
        <div style={{ width: 32, height: 32, borderRadius: 6, background: value || '#000000', border: `1px solid ${C.b1}` }} />
      </div>
    </div>
  );
}
